
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blood-home",
      function () {
        return require("private-next-pages/blood-home/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blood-home"])
      });
    }
  